import { initializeApp, getApps, getApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { getDatabase } from "firebase/database";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
  // Hardcoded fallback to the CORRECT region. Without the right region URL, getDatabase()
  // silently connects to the default (us-central) DB which is EMPTY → RTDB live progress
  // (incl. finishedAt) never arrives, breaking the leaderboard. Must match the backend.
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL
    || "https://vionix-vionixasia-default-rtdb.asia-southeast1.firebasedatabase.app"
};

// Initialize Firebase
const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);
const analytics = typeof window !== "undefined" ? getAnalytics(app) : null;
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);
const functions = getFunctions(app);
const googleProvider = new GoogleAuthProvider();
// Pass the region URL DIRECTLY to getDatabase — the most reliable way to force the
// correct RTDB. Relying on firebaseConfig.databaseURL alone failed (the value wasn't
// reaching app.options), so getDatabase() defaulted to the empty us-central DB.
const realtimeDb = getDatabase(
  app,
  import.meta.env.VITE_FIREBASE_DATABASE_URL
    || "https://vionix-vionixasia-default-rtdb.asia-southeast1.firebasedatabase.app"
);

export { app, auth, db, storage, functions, analytics, googleProvider, realtimeDb };